import * as cheerio from 'cheerio'

export const pickPublicationScope = (vacancy) => {
  let publication

  vacancy?.publicationScopes?.forEach((pub) => {
    if (pub.scope === 'internal') {
      publication = pub
    } else if (pub.scope === 'regional' && publication?.scope !== 'internal') {
      publication = pub
    } else if (!publication) {
      publication = pub
    }
  })

  return publication
}

export const normalizeHeadingsToH2Max = (htmlString) => {
  if (typeof window === 'undefined') {
    // Server-side using Cheerio
    const $ = cheerio.load(htmlString)

    const headings = $('h1, h2, h3, h4, h5, h6')
    if (headings.length === 0) return htmlString

    let maxLevel = 6
    headings.each((i, el) => {
      const level = parseInt(el.tagName.substring(1))
      if (level < maxLevel) maxLevel = level
    })

    const offset = 2 - maxLevel

    headings.each((i, el) => {
      const currentLevel = parseInt(el.tagName.substring(1))
      let newLevel = Math.max(1, Math.min(6, currentLevel + offset))
      $(el).replaceWith($(`<h${newLevel}>`).html($(el).html()))
    })

    return $.html()
  } else {
    // Client-side using native DOM
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = htmlString

    const headings = tempDiv.querySelectorAll('h1, h2, h3, h4, h5, h6')
    if (headings.length === 0) return htmlString

    let maxLevel = 6
    headings.forEach((heading) => {
      const level = parseInt(heading.tagName.substring(1))
      if (level < maxLevel) maxLevel = level
    })

    const offset = 2 - maxLevel

    headings.forEach((heading) => {
      const currentLevel = parseInt(heading.tagName.substring(1))
      let newLevel = Math.max(1, Math.min(6, currentLevel + offset))
      const newHeading = document.createElement(`h${newLevel}`)
      newHeading.innerHTML = heading.innerHTML

      for (let attr of heading.attributes) {
        newHeading.setAttribute(attr.name, attr.value)
      }

      heading.parentNode.replaceChild(newHeading, heading)
    })

    return tempDiv.innerHTML
  }
}

export const isVacancyActive = (vacancy, renderedPageSlug, siteGracePeriod) => {
  if (!vacancy) return false
  if (import.meta.env.VITE_IS_EDITOR) return true

  const publication = pickPublicationScope(vacancy)
  if (!publication) {
    // If the vacancy doesn't have a publication and we're using the template page, the vacancy is considered as unavailable
    return !renderedPageSlug.includes('/_default/_vacancy')
  } else {
    const remainingDays = daysUntilClosure(publication.end)
    if (remainingDays < 0) {
      // If the vacancy already closed, we check the site's grace period to determine if it's available
      return remainingDays * -1 <= siteGracePeriod
    } else {
      return true
    }
  }
}

export const hasSupportedApplyForm = (applyUrl) => {
  return ['vacatures.one', 'ubeeo.hellopublic.nl'].some((domain) =>
    applyUrl?.includes(domain),
  )
}

export const daysUntilClosure = (endDateStr) => {
  if (!endDateStr) return -1

  const start = new Date()
  const end = new Date(endDateStr)

  // Calculate the difference in time (milliseconds)
  const differenceInTime = end - start

  // Convert the difference from milliseconds to days
  const differenceInDays = Math.floor(differenceInTime / (1000 * 60 * 60 * 24))

  return differenceInDays
}
